<script setup>
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid'

defineProps({
  message: {
    type: String,
  },
})
</script>

<template>
  <div class="rounded-md bg-red-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <ExclamationTriangleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
      </div>
      <div class="text-sm text-red-700 ml-3">
        <p>{{ message }}</p>
      </div>
    </div>
  </div>
</template>
<style scoped></style>
